import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import transportIcon from "../../../../../assets/new-product-detail-cats/header-icons/prod-deliveries-icon.svg";
import { useTranslation } from "react-i18next";
import formatDate from "../../components/HeaderBox/formatDate";
import { getTransportation38Totals } from "../../../../../apis/Product/TransportationFlow38Api";

const Transportation38Icon = () => (
  <img src={transportIcon} alt="Transportation 38 Icon" width={76} height={76} />
);

const Transportation38Header = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalProdItem, setTotalProdItem] = useState(null);

  useEffect(() => {
    if (productId) {
      getTransportation38Totals({
        productId,
        setTotals: setTotalProdItem,
      });
    }
  }, [productId]);

  return (
    <CategoryComponent
      show={show}
      className={`transportation-38-category ${className || ""}`}
      leftBoxProps={{
        icon: <Transportation38Icon />,
        title: t("TRANSPORTATION_38") || "Transportation to the use stage",
        description:
          t("TRANSPORTATION_38_DESC") ||
          "Transportation and deliveries to the use stage.",
        productId: productId,
        isSystemBoundary: false,
        customTextColor: "white",
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: "",
                subitems: [],
              },
            ],
            isSwitchable: true,
          },
          // {
          //   title: t("TOTAL_FOR_FLOW_38") || "Total for Flow 38",
          //   items: [
          //     {
          //       subtitle: "",
          //       subitems: [],
          //     },
          //   ],
          //   isSwitchable: true,
          // },
        ],
        impactTotals: totalProdItem?.impact_totals || null,
        lastUpdated: totalProdItem?.updated_at
          ? formatDate(totalProdItem?.updated_at)
          : t("DD_MM_YYYY"),
        customTextColor: "white",
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default Transportation38Header;

